export const OPTED_IN = 'in';
export const OPTED_OUT = 'out';
export const DNTED = 'dnt';
export const NO_CHOICE = 'choose';

export const JS_AND_CSS_BASENAME = 'privacy-policy';
export const domainTokens = {
  default: 'europarl',
};
